import api from './api';

export default {
    async login (data) {
        return await api.call( 'login', data);
    },
    async register (data) {
        return await api.call( 'register', data);
    },
    async logout () {
        return await api.call( 'logout');
    },
}